import axiosInstance from './axiosConfig';

export const getSecurityOverviewApi = () => axiosInstance.get('/security/overview');
export const getLockedUsersApi = () => axiosInstance.get('/security/locked-users');
export const getUnlockRequestsApi = (params) => axiosInstance.get('/security/unlock-requests', { params });
export const approveUnlockRequestApi = (id, adminNote) =>
  axiosInstance.post(`/security/unlock-requests/${id}/approve`, { adminNote });
export const rejectUnlockRequestApi = (id, adminNote) =>
  axiosInstance.post(`/security/unlock-requests/${id}/reject`, { adminNote });
export const unlockUserApi = (id) => axiosInstance.post(`/security/users/${id}/unlock`);
export const resetUserTwoFactorApi = (id) => axiosInstance.post(`/security/users/${id}/reset-2fa`);
export const getLoginLogsApi = (params) => axiosInstance.get('/security/login-logs', { params });
